import React, { useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useConfirm } from 'material-ui-confirm';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { hideModal } from 'state/actions';
import { ShootingContextProvider, ShootingContext } from 'contexts';
import { HvModal } from 'components';
import { MODAL } from 'config/constants';
import { ShootingWizard } from '../components';

const useStyles = makeStyles({
  shootingModal: {
    '@media (min-width: 1024px)': {
      width: '60%',
      height: '100%',
      maxWidth: 1000,
    },

    '@media (max-width: 767px)': {
      width: '90%',
    },

    '& .MuiDialogTitle-root h2': {
      fontWeight: 600,
    },

    '& .MuiDialog-paper': {
      width: '100%',
      maxWidth: 'none',
      margin: 'auto',
    },
  },
});

interface Props {
  shootingId: number;
  isUpdateDate: boolean;
  bookAnotherShoot: boolean;
}

function ShootingEditModal({ shootingId, isUpdateDate = false, bookAnotherShoot }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const confirm = useConfirm();
  const dispatch = useDispatch();
  const [title, setTitle] = useState('');
  const [isChanged, setIsChanged] = useState(false);
  const { setIgnoreRecommendation } = useContext(ShootingContext);
  const onClose = () => {
    if (!isChanged) {
      dispatch(hideModal(MODAL.SHOOTING_EDIT));
      setIgnoreRecommendation(false);
    } else {
      confirm({
        title: intl.formatMessage({ id: 'shooting.create.confirm.unsavedDataTitle' }),
        description: intl.formatMessage({ id: 'shooting.create.confirm.unsavedDataMessage' }),
        confirmationText: intl.formatMessage({ id: 'shooting.create.confirm.unsavedDataGoBack' }),
        cancellationText: intl.formatMessage({ id: 'shooting.create.buttons.cancel' }),
        dialogProps: { classes: { root: 'ConfirmDialog' } },
        confirmationButtonProps: {
          variant: 'contained',
          color: 'secondary',
          style: { color: 'white' },
        },
        cancellationButtonProps: { variant: 'contained' },
      }).then(() => {
        dispatch(hideModal(MODAL.SHOOTING_EDIT));
        setIgnoreRecommendation(false);
      });
    }
  };

  return (
    <HvModal className={styles.shootingModal} title={title} onClose={onClose}>
      <ShootingContextProvider
        shootingId={shootingId}
        isChanged={isChanged}
        setIsChanged={setIsChanged}
        bookAnotherShoot={bookAnotherShoot}
      >
        <ShootingWizard isUpdateDate={isUpdateDate} updateTitle={setTitle} onClose={onClose} />
      </ShootingContextProvider>
    </HvModal>
  );
}

ShootingEditModal.defaultProps = {
  shootingId: undefined,
};

ShootingEditModal.propTypes = {
  shootingId: PropTypes.number,
};

export default ShootingEditModal;
